module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"processing_title":"Verifying your informations...","processing_text":"Please wait and do not close or refresh this page","success_title":"Congratulations!","success_text":"You are elegible for this program","error_title":"Ops..","error_text":"Sorry, you are not eligible for this program."}}')
  delete Component.options._Ctor
}
